import { axios } from '@/services/axios';

const getSSOConfig = async (currentCompany) => {
    const res = await axios.get(`/sso/${currentCompany}`);
    return res.data;
};

export default getSSOConfig;
